import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const publicRegistry = {
  queryKey: queryKeys.publicRegistry,
  queryFn: Api.getPublicRegistry,
};
